import { render, staticRenderFns } from "./NewBrief.vue?vue&type=template&id=510a04a7"
import script from "./NewBrief.vue?vue&type=script&lang=js"
export * from "./NewBrief.vue?vue&type=script&lang=js"
import style0 from "./NewBrief.vue?vue&type=style&index=0&id=510a04a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports